function getDoubleDpiSrc(src) {
  const url = new URL(src);
  const connector = url.search ? '&' : '?';
  return src ? `${src}, ${src}${connector}dpi=1.5 1.5x` : '';
}

export default getDoubleDpiSrc;
